var _rect, _rect2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddimage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 17,
    width: 4,
    height: 76,
    fill: "black",
    fillOpacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 57,
    width: 4,
    height: 76,
    transform: "rotate(-90 17 57)",
    fill: "black",
    fillOpacity: 0.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55,
    r: 53,
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddimage);
export default __webpack_public_path__ + "static/media/addimage.aa4589ccfe130ffacb703375b4707b20.svg";
export { ForwardRef as ReactComponent };